module.exports = __webpack_public_path__ + "img/staticclingcobrand.707116f2.png";